import React, { useEffect, useState } from "react";
import Layout from "../../components/Wrappers/Layout";
import { useSelector, useDispatch } from "react-redux";
import { swalWithBootstrapButtons } from "../../utils/sweetalert";
import LinkIcon from "@mui/icons-material/Link";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { FileExcelFilled } from "@ant-design/icons";
import FileBase64 from "../../components/Upload/UploadFile";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import SOLogout from "../../components/Logout/SOLogout";
import Autocomplete from "@mui/lab/Autocomplete";
import TextField from "@mui/material/TextField";
import { getCustomerIdAndNameList } from "../../redux/actions/getCustomerIdAndNameListAction";
import {
    uploadToGenerateLinkAction,
    resetUploadToGenerateLink,
} from "../../redux/actions/uploadtogeneratelinkAction";

const GenerateLink = () => {
    const dispatch = useDispatch();
    const login = useSelector((state) => state.login);
    const regenerateTokenRes = useSelector(({ regenerateToken }) => regenerateToken);
    const authToken = login.data.AuthToken;

    const [uploadFile, setUploadFile] = useState("");
    const [UploadFileName, setUploadFileName] = useState("");
    const [btnDisable, setBtnDisable] = useState(true);
    const [copied, setCopied] = useState(false);
    const [customerId, setCustomerId] = useState("");
    const [generateLinkStatus, setGenerateLinkStatus] = useState(false);
    const [generatedLink, setGeneratedLink] = useState("");
    const [fileInputKey, setFileInputKey] = useState(0);
    const [isDragging, setIsDragging] = useState(false);

    const uploadToGenerateLinkRes = useSelector(
        ({ uploadtogeneratelink }) => uploadtogeneratelink
    );
    const getCustomerIdAndNameListRes = useSelector(
        ({ getCustomerIdAndNameList }) => getCustomerIdAndNameList
    );

    const downloadExcel = (base64Excel, fileName = "GeneratedLink_Report.xlsx") => {
        if (!base64Excel) return;
        const byteCharacters = atob(base64Excel);
        const byteNumbers = new Array(byteCharacters.length)
            .fill(null)
            .map((_, i) => byteCharacters.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    useEffect(() => {
        const req = {
            loginDetails: {
                walletOwnerId:
                    login.data.subRole === ""
                        ? login.data.partnerId
                        : login.data.parentId,
            },
            actionCustomerMasterRequestVO: { customerNameOrId: "" },
        };
        dispatch(getCustomerIdAndNameList(req, authToken));
    }, []);

    const resetFields = () => {
        setCustomerId("");
        setUploadFile("");
        setUploadFileName("");
        setBtnDisable(true);
        setFileInputKey((prev) => prev + 1);
    };

    useEffect(() => {
        if (!generateLinkStatus) return;

        if (uploadToGenerateLinkRes.data.status === "success") {
            setGeneratedLink(uploadToGenerateLinkRes.data.link || "");
            if (uploadToGenerateLinkRes.data.updatedExcel) {
                downloadExcel(uploadToGenerateLinkRes.data.updatedExcel);
            }
            swalWithBootstrapButtons.fire({
                type: "success",
                title: "Link Generated Successfully",
            });
            dispatch(resetUploadToGenerateLink());
            setGenerateLinkStatus(false);
            resetFields();
        }

        if (
            uploadToGenerateLinkRes.data.status === "failed" ||
            uploadToGenerateLinkRes.data.status === "Failed"
        ) {
            if (uploadToGenerateLinkRes.data.updatedExcel) {
                downloadExcel(uploadToGenerateLinkRes.data.updatedExcel);
            }
            swalWithBootstrapButtons.fire({
                type: "error",
                title: "Link Generation Failed",
            });
            if (uploadToGenerateLinkRes.data.description === "session out") {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (uploadToGenerateLinkRes.data.description === "Authorization failed") {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            dispatch(resetUploadToGenerateLink());
            setGenerateLinkStatus(false);
            resetFields();
        }
    }, [uploadToGenerateLinkRes.data.status]);

    const filterOptionsL = (options, { inputValue }) => {
        if (inputValue.length < 3) return [];
        return options.filter((option) => option.includes(inputValue)).slice(0, 20);
    };

    const handleAttachmentsDoc = (e, field) => {
        if (field === "uploadFile") {
            setUploadFile(e.base64);
            setUploadFileName(e.name);
            setBtnDisable(false);
        }
    };

    const handleGenerateLink = () => {
        setGenerateLinkStatus(true);
        const extractedCustomerId = customerId ? customerId.split("-")[0].trim() : "";
        const base64File = uploadFile.split(",")[1];
        const req = {
            loginDetails: {
                walletOwnerId: login.data.partnerId || "",
                customerId: extractedCustomerId,
            },
            actionCustomerMasterRequestVO: {
                infoFile: base64File,
            },
        };
        dispatch(uploadToGenerateLinkAction(req, authToken));
    };

    const handleCopyLink = () => {
        if (generatedLink) {
            navigator.clipboard.writeText(generatedLink).then(() => {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            });
        }
    };

    return (
        <Layout>
            <div className="gl-wrapper">
                <div className="gl-card">

                    {/* ── Header ── */}
                    <div className="gl-header">
                        <div className="gl-header-icon">
                            <LinkIcon />
                        </div>
                        <div>
                            <p className="gl-header-title">Generate Link</p>
                            <p className="gl-header-sub">
                                Upload a file to create a shareable payment link
                            </p>
                        </div>
                    </div>

                    {/* ── 3-column grid (stacks to 1 col on mobile) ── */}
                    <div className="gl-grid">

                        {/* Customer ID */}
                        <div>
                            <label className="gl-label">Customer / Merchant ID</label>
                            <Autocomplete
                                id="combo-box-demo"
                                options={[].concat(
                                    getCustomerIdAndNameListRes.data.currencyList || [""]
                                )}
                                getOptionLabel={(option) => option}
                                filterOptions={filterOptionsL}
                                value={customerId}
                                onChange={(event, newValue) => setCustomerId(newValue || "")}
                                onInputChange={(event, newInputValue) =>
                                    setCustomerId(newInputValue)
                                }
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Search by name or ID..."
                                        variant="outlined"
                                        size="small"
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: "10px",
                                                fontSize: "14px",
                                                background: "#fafbfc",
                                                "& fieldset": { borderColor: "#d0d5e0" },
                                                "&:hover fieldset": { borderColor: "#9ba5b5" },
                                                "&.Mui-focused fieldset": {
                                                    borderColor: "#1B5FBF",
                                                },
                                            },
                                        }}
                                    />
                                )}
                            />
                        </div>

                        {/* File Upload */}
                        <div>
                            <label className="gl-label">Link File</label>
                            <div
                                className={`gl-upload-zone${isDragging ? " dragging" : ""}`}
                                onDragOver={(e) => {
                                    e.preventDefault();
                                    setIsDragging(true);
                                }}
                                onDragLeave={() => setIsDragging(false)}
                                onDrop={(e) => {
                                    e.preventDefault();
                                    setIsDragging(false);
                                }}
                            >
                                <CloudUploadIcon className="gl-upload-icon" />
                                <span className="gl-upload-text">
                                    <span>Choose file</span> or drag & drop
                                </span>
                                <span className="gl-upload-ext">
                                    xlsx, csv
                                </span>
                                <FileBase64
                                    key={fileInputKey}
                                    multiple={false}
                                    name={false}
                                    id="documentGuard"
                                    accept=".csv, .xls, .xlsx"
                                    onDone={(e) => handleAttachmentsDoc(e, "uploadFile")}
                                    showUploadList={false}
                                    value={UploadFileName}
                                />
                            </div>
                            {UploadFileName && (
                                <div className="gl-file-pill">
                                    <InsertDriveFileIcon />
                                    <span>{UploadFileName}</span>
                                </div>
                            )}
                        </div>

                        {/* Sample File Format */}
                        <div>
                            <label className="gl-label">Template</label>
                            <button className="gl-sample-btn">
                                <FileExcelFilled style={{ color: "#3d8c40", fontSize: "16px" }} />
                                Sample File Format
                            </button>
                        </div>
                    </div>

                    <hr className="gl-divider" />

                    {/* ── Generate button + hint ── */}
                    <div className="gl-actions">
                        <button
                            className="gl-generate-btn"
                            disabled={btnDisable}
                            onClick={handleGenerateLink}
                        >
                            <LinkIcon />
                            Generate Link
                        </button>
                        <span className={`gl-hint${!btnDisable ? " ready" : ""}`}>
                            {btnDisable
                                ? "Select a customer and upload a file to continue"
                                : "Ready — click to generate your link"}
                        </span>
                    </div>

                    {/* ── Result row ── */}
                    {generatedLink && (
                        <div className="gl-result">
                            <div className="gl-result-icon">
                                <CheckIcon />
                            </div>
                            <div className="gl-result-content">
                                <div className="gl-result-label">Generated Link</div>
                                <span className="gl-result-link">{generatedLink}</span>
                            </div>
                            <button className="gl-copy-btn" onClick={handleCopyLink}>
                                <ContentCopyIcon />
                                {copied ? "Copied!" : "Copy"}
                            </button>
                        </div>
                    )}

                </div>
            </div>
        </Layout>
    );
};

export default GenerateLink;